import { useAccountsInfo } from '@/entities/account/api';
import { usePendingAccountsStore } from '@/features/account-open';
import { useEffect } from 'react';

export const useSyncPendingAccounts = () => {
  const { accountsInfo, isAccountsInfoLoading } = useAccountsInfo();
  const { pendingAccounts, removePendingAccount } = usePendingAccountsStore();

  useEffect(() => {
    if (!accountsInfo || pendingAccounts.length === 0) return;

    accountsInfo.accounts.forEach(existedAcc => {
      if (
        pendingAccounts.some(
          pending => Number(pending.accountNumber) === existedAcc?.tradingAccKey
        )
      ) {
        removePendingAccount(String(existedAcc?.tradingAccKey));
      }
    });
  }, [accountsInfo, pendingAccounts, isAccountsInfoLoading]);
};
